(() => {
  if (window.barbaraCookieSettingsReady) return;
  window.barbaraCookieSettingsReady = true;
  let loading;
  const loadBannerApi = () => {
    if (window.privacyBanner?.showPreferences) return Promise.resolve(window.privacyBanner);
    if (!loading) loading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
      script.onload = () => window.privacyBanner?.showPreferences ? resolve(window.privacyBanner) : reject(new Error('Privacy interface unavailable'));
      script.onerror = reject;
      document.head.appendChild(script);
    }).catch(error => { loading = null; throw error; });
    return loading;
  };
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-barbara-cookie-settings]');
    if (!trigger) return;
    event.preventDefault();
    const status = document.querySelector('[data-barbara-cookie-status]');
    if (status) status.textContent = '';
    trigger.setAttribute('aria-busy', 'true');
    document.dispatchEvent(new CustomEvent('barbara:privacy-opening'));
    try {
      const api = await loadBannerApi();
      await api.showPreferences();
    } catch {
      if (status) status.textContent = status.dataset.error;
      else if (trigger.href) location.assign(trigger.href);
    } finally {
      trigger.removeAttribute('aria-busy');
    }
  });

  // Keep the feed-specific information visible inside the native Marketing preference.
  // This explains the selection; it never changes a consent value or activates the feed.
  const syncInstagramInformation = () => {
    const source = document.querySelector('[data-bec-instagram-notice]');
    const targets = [
      document.getElementById('shopify-pc__prefs__marketing'),
      document.querySelector('#shopify-pc__banner .shopify-pc__banner__body')
    ].filter(Boolean);
    if (!source || !targets.length) return;
    const heading = source.querySelector('h2');
    const description = source.querySelector('p');
    const privacy = source.querySelector('a[href*="privacy-policy"]');
    if (!heading || !description || !privacy) return;
    for (const target of targets) {
    let note = target.querySelector('[data-bec-instagram-cookie-notice]');
    if (!note) {
      note = document.createElement('div');
      note.setAttribute('data-bec-instagram-cookie-notice', '');
      note.style.marginTop = '12px';
      note.style.paddingTop = '12px';
      note.style.borderTop = '1px solid #dfdfdf';
      const title = document.createElement('p');
      const strong = document.createElement('strong');
      title.appendChild(strong);
      const text = document.createElement('p');
      const link = document.createElement('a');
      note.append(title, text, link);
      target.appendChild(note);
    }
    const strong = note.querySelector('strong');
    const text = note.querySelectorAll('p')[1];
    const link = note.querySelector('a');
    if (strong.textContent !== heading.textContent) strong.textContent = heading.textContent;
    if (text.textContent !== description.textContent) text.textContent = description.textContent;
    if (link.textContent !== privacy.textContent) link.textContent = privacy.textContent;
    if (link.getAttribute('href') !== privacy.getAttribute('href')) {
      link.setAttribute('href', privacy.getAttribute('href'));
    }
    }
  };
  const observePrivacyInformation = () => {
    if (!document.querySelector('[data-bec-instagram-notice]')) return;
    let pending = false;
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        syncInstagramInformation();
      });
    }).observe(document.body, { childList: true, subtree: true });
    syncInstagramInformation();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observePrivacyInformation, { once: true });
  } else observePrivacyInformation();
})();

(() => {
  // Keep the native decision controls visible on narrow, short screens.
  const style = document.createElement('style');
  style.id = 'bec-cookie-mobile-layout';
  style.textContent = `
    @media (max-width: 749px) {
      #shopify-pc__banner .shopify-pc__banner__wrapper {
        display: flex !important; flex-direction: column !important;
        min-height: 0; max-height: calc(90vh - 64px);
        max-height: calc(90dvh - 64px);
      }
      #shopify-pc__banner .shopify-pc__banner__body {
        min-height: 0; overflow-y: auto; overscroll-behavior: contain;
        padding-right: 4px;
      }
      #shopify-pc__banner .shopify-pc__banner__btns {
        flex-shrink: 0; margin-top: 16px;
      }
      #shopify-pc__banner .shopify-pc__banner__btns button { min-height: 44px; }
      body:has(#PBarNextFrame) #shopify-pc__banner { bottom: 64px; }
      body:has(#PBarNextFrame) #shopify-pc__banner .shopify-pc__banner__wrapper {
        max-height: calc(90vh - 128px); max-height: calc(90dvh - 128px);
      }
    }`;
  document.head.appendChild(style);

  // Repair the dangling list reference without changing Shopify's region checks.
  if (!location.pathname.endsWith('/pages/data-sharing-opt-out')) return;
  const de = document.documentElement.lang.toLowerCase().startsWith('de');
  const replacement = de
    ? 'Die Online-Funktion zur Ablehnung der Datenweitergabe steht in den dafür eingerichteten US-Bundesstaaten zur Verfügung. Optionale Cookies können über die Cookie-Einstellungen abgelehnt werden.'
    : 'The online data sharing opt-out function is available in the U.S. states configured for this function. Optional cookies can be declined in Cookie Settings.';
  const update = () => {
    const target = document.querySelector('#pc--opt-out-not-applicable strong');
    if (target && target.textContent !== replacement) target.textContent = replacement;
  };
  const initialize = () => {
    const main = document.querySelector('#MainContent');
    if (!main) return;
    new MutationObserver(update).observe(main, { childList: true, subtree: true });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
